var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrainElectricitywhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1118 28.8457C10.7981 28.8457 8.11182 31.532 8.11182 34.8457C8.11182 38.1594 10.7981 40.8457 14.1118 40.8457C14.8131 40.8457 15.4863 40.7254 16.1118 40.5043",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63965 32.0545C5.96041 30.7617 4.11189 28.0193 4.11189 24.8452C4.11189 22.4219 5.18936 20.2503 6.89137 18.7832",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95287 18.6221C6.42161 17.8279 6.11182 16.873 6.11182 15.8457C6.11182 13.0843 8.35039 10.8457 11.1118 10.8457C12.2376 10.8457 13.2766 11.2178 14.1123 11.8457",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5872 11.9764C14.2823 11.33 14.1118 10.6078 14.1118 9.8457C14.1118 7.08428 16.3504 4.8457 19.1118 4.8457C21.8732 4.8457 24.1118 7.08428 24.1118 9.8457V40.8457",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1118 40.8457C16.1118 43.0548 17.9027 44.8457 20.1118 44.8457C22.321 44.8457 24.1118 43.0548 24.1118 40.8457",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1119 14.8457C24.1119 18.1594 26.7982 20.8457 30.1119 20.8457",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3323 18.7832C43.0343 20.2503 44.1118 22.4219 44.1118 24.8452C44.1118 26.2514 43.749 27.5729 43.1119 28.7211",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2708 18.6221C41.8021 17.8279 42.1119 16.873 42.1119 15.8457C42.1119 13.0843 39.8733 10.8457 37.1119 10.8457C35.9861 10.8457 34.9471 11.2178 34.1114 11.8457",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1119 9.8457C24.1119 7.08428 26.3505 4.8457 29.1119 4.8457C31.8733 4.8457 34.1119 7.08428 34.1119 9.8457C34.1119 10.6078 33.9414 11.33 33.6365 11.9764",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1119 44.8457C25.9027 44.8457 24.1119 43.0548 24.1119 40.8457",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4451 32.8457L34.1118 38.8457H42.1118L38.7785 44.8457",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainElectricitywhite);
export default __webpack_public_path__ + "static/media/brain-electricitywhite.dfd933cf0438bd476b6e03014294f29a.svg";
export { ForwardRef as ReactComponent };